import { render } from "./InscricoesPage.vue?vue&type=template&id=6630063a&scoped=true"
import script from "./InscricoesPage.vue?vue&type=script&lang=js"
export * from "./InscricoesPage.vue?vue&type=script&lang=js"

import "./InscricoesPage.vue?vue&type=style&index=0&id=6630063a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6630063a"]])

export default __exports__